import { LogOut, LayoutDashboard, Contact, AudioWaveform } from 'lucide-react';
// import Projects from './Projects';
// import Dashboard from './Dashboard';
import { AlignJustify } from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { useState, useRef, useEffect } from 'react';

const Header = (props) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };

        if (menuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuOpen]);

    const navLinkBase = "menuLink flex items-center gap-1.5 text-xs font-medium tracking-wider uppercase px-3 py-1.5 rounded-md transition-all duration-200";
    const navActive = `${navLinkBase} text-[#ffee00] bg-[rgba(255,238,0,0.08)]`;
    const navInactive = `${navLinkBase} text-[#888] hover:text-[#ffee00] hover:bg-[rgba(255,238,0,0.05)]`;

    return (
        <>
            <header className='px-6 py-0 fixed top-0 left-0 w-full h-16 z-50'>
                <span
                    className="font-Tsukimi font-semibold ml-0 mb-1 text-lg tracking-wide"
                    style={{ textShadow: '0 0 20px rgba(255,238,0,0.3)' }}
                >
                    mixbus
                </span>

                <menu id="menu-main" className='flex gap-1 items-center'>
                    <NavLink to="/" className={({ isActive }) => isActive ? navActive : navInactive}>
                        <LayoutDashboard size={14}/><span>dashboard</span>
                    </NavLink>
                    <NavLink to="projects" className={({ isActive }) => isActive ? navActive : navInactive}>
                        <AudioWaveform size={14}/><span>projects</span>
                    </NavLink>
                    <NavLink to="clients" className={({ isActive }) => isActive ? navActive : navInactive}>
                        <Contact size={14}/><span>clients</span>
                    </NavLink>
                    <button
                        onClick={props.logout}
                        className="menuLink flex items-center gap-1.5 text-xs font-medium tracking-wider uppercase px-3 py-1.5 rounded-md text-[#555] hover:text-[#e44] hover:bg-[rgba(220,0,0,0.06)] transition-all duration-200 ml-2"
                    >
                        <LogOut size={14}/><span>logout</span>
                    </button>
                </menu>

                <menu id="menu-dropdown" ref={dropdownRef} className="relative inline-block">
                    <button
                        onClick={() => setMenuOpen(!menuOpen)}
                        className="p-2 rounded-md transition-colors duration-200"
                        style={{ color: menuOpen ? "#ffee00" : "#888" }}
                    >
                        <AlignJustify size={20}/>
                    </button>
                    <div
                        id="menu-dropdown-content"
                        className={menuOpen ? "visible" : "hidden"}
                    >
                        <NavLink to="/" className={({ isActive }) => isActive ? navActive : navInactive} onClick={() => setMenuOpen(false)}>
                            <LayoutDashboard size={14}/><span>dashboard</span>
                        </NavLink>
                        <NavLink to="projects" className={({ isActive }) => isActive ? navActive : navInactive} onClick={() => setMenuOpen(false)}>
                            <AudioWaveform size={14}/><span>projects</span>
                        </NavLink>
                        <NavLink to="clients" className={({ isActive }) => isActive ? navActive : navInactive} onClick={() => setMenuOpen(false)}>
                            <Contact size={14}/><span>clients</span>
                        </NavLink>
                        <button
                            onClick={props.logout}
                            className="menuLink flex items-center gap-1.5 text-xs font-medium tracking-wider uppercase px-3 py-1.5 rounded-md text-[#555] hover:text-[#e44] hover:bg-[rgba(220,0,0,0.06)] transition-all duration-200 w-full"
                        >
                            <LogOut size={14}/><span>logout</span>
                        </button>
                    </div>
                </menu>
            </header>
        </>
    );
};

export default Header;
